/* ============================================================
   LOOMERA THEME — JavaScript
   Vanilla JS. No frameworks. Scroll reveals, parallax, nav.
   ============================================================ */

(function () {
  'use strict';

  /* ── Intersection Observer: Scroll Reveals ─────────────────
     Finds all .reveal and [data-reveal-stagger] elements,
     adds .is-visible when they enter the viewport.
  ─────────────────────────────────────────────────────────── */
  function initScrollReveal() {
    var targets = document.querySelectorAll('.reveal, [data-reveal-stagger]');
    if (!targets.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -48px 0px',
      }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ── Parallax: Hero Image ──────────────────────────────────
     Soft vertical parallax on the hero image wrap.
     Disables on mobile to preserve performance.
  ─────────────────────────────────────────────────────────── */
  function initHeroParallax() {
    var hero = document.querySelector('.loom-hero__image-wrap');
    if (!hero) return;

    // Skip parallax on touch/mobile devices
    if (window.matchMedia('(max-width: 749px)').matches) return;
    if (!window.matchMedia('(prefers-reduced-motion: no-preference)').matches) return;

    var ticking = false;

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(function () {
          var scrolled = window.scrollY;
          var rate = scrolled * 0.22;
          hero.style.transform = 'translateY(' + rate + 'px)';
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ── Nav: Scroll-aware state ───────────────────────────────
     Adds data-scrolled attr to header wrapper after threshold.
     Use in CSS: .header-wrapper[data-scrolled] { ... }
  ─────────────────────────────────────────────────────────── */
  function initScrollNav() {
    var header = document.querySelector('.header-wrapper');
    if (!header) return;

    var THRESHOLD = 60;
    var ticking = false;

    function update() {
      if (!ticking) {
        requestAnimationFrame(function () {
          if (window.scrollY > THRESHOLD) {
            header.setAttribute('data-scrolled', '');
          } else {
            header.removeAttribute('data-scrolled');
          }
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ── Email Form: UX Feedback ───────────────────────────────
     Handles the loom-email form submission feedback.
     Klaviyo integration hooks via data-klaviyo-list-id
     on the form element.
  ─────────────────────────────────────────────────────────── */
  function initEmailForm() {
    var section = document.querySelector('.loom-email');
    if (!section) return;

    var form = section.querySelector('.loom-email__form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      var input = form.querySelector('.loom-email__input');
      if (!input || !input.value.trim()) {
        e.preventDefault();
        input && input.focus();
        return;
      }

      // Klaviyo custom identify (if Klaviyo script loaded)
      var listId = form.getAttribute('data-klaviyo-list-id');
      if (listId && window._learnq) {
        e.preventDefault();
        window._learnq.push(['identify', { '$email': input.value.trim() }]);
        window._learnq.push(['track', 'Newsletter Signup', { list_id: listId }]);
        section.classList.add('loom-email--submitted');
        return;
      }

      // Native Shopify form submission — let it go through
      // but visually update after a short delay
      setTimeout(function () {
        var btn = form.querySelector('.loom-email__submit');
        if (btn) {
          btn.textContent = 'Sent';
          btn.disabled = true;
        }
      }, 100);
    });
  }

  /* ── Ritual Steps: Staggered reveal ─────────────────────────
     The ritual steps use [data-reveal-stagger] + custom
     per-child delays handled in CSS. This JS just ensures
     the parent gets observed correctly.
  ─────────────────────────────────────────────────────────── */
  function initRitualReveal() {
    var steps = document.querySelector('.loom-ritual__steps');
    if (!steps) return;
    // Already handled by initScrollReveal via [data-reveal-stagger]
    // Nothing extra needed here.
  }

  /* ── Announcement bar: horizontal marquee ─────────────────
     If the social-proof strip has overflowing content on
     narrow viewports, this doesn't apply marquee — handled
     with flex-wrap in CSS. Reserved for future use.
  ─────────────────────────────────────────────────────────── */

  /* ── Init ──────────────────────────────────────────────────
     Safe to run after DOMContentLoaded.
  ─────────────────────────────────────────────────────────── */
  function initCartIconDrawer() {
    var cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon) return;
    cartIcon.addEventListener('click', function (e) {
      e.preventDefault();
      refreshAndOpenDrawer();
    });
  }

  /* ── Sticky Mobile CTA ──────────────────────────────────────
     Slides up from the bottom on mobile after the hero
     scrolls out of view. Hides again when the email capture
     section comes into view (the email form takes over as the
     primary CTA at the end of the page).
  ─────────────────────────────────────────────────────────── */
  function initStickyCta() {
    var bar = document.querySelector('[data-loom-sticky-cta]');
    if (!bar) return;
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    var hero = document.querySelector('.loom-hero, .loom-pdp-hero');
    var email = document.querySelector('.loom-email');

    var heroOut = !hero;
    var emailIn = false;

    function update() {
      if (heroOut && !emailIn) {
        bar.removeAttribute('hidden');
        // double rAF to allow browser to apply [hidden] removal before transitioning
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            bar.classList.add('is-visible');
          });
        });
      } else {
        bar.classList.remove('is-visible');
      }
    }

    if (hero) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            heroOut = !e.isIntersecting;
            update();
          });
        },
        { threshold: 0 }
      ).observe(hero);
    }

    if (email) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            emailIn = e.isIntersecting;
            update();
          });
        },
        { threshold: 0.2 }
      ).observe(email);
    }

    if (!hero && !email) {
      // Standalone case: no observers — just reveal immediately on mobile
      heroOut = true;
      update();
    }
  }

  /* ── Hero Slider ────────────────────────────────────────────
     Crossfade carousel for [data-hero-slider]. Auto-advances
     on data-interval (ms). Pauses on hover/focus and when the
     tab is hidden. Respects prefers-reduced-motion (no autoplay).
  ─────────────────────────────────────────────────────────── */
  function initHeroSlider() {
    var slider = document.querySelector('[data-hero-slider]');
    if (!slider) return;

    var slides = slider.querySelectorAll('.loom-hero__slide');
    var dots = slider.querySelectorAll('.loom-hero__dot');
    if (slides.length < 2) return;

    var interval = parseInt(slider.dataset.interval, 10) || 7000;
    var current = 0;
    var timer = null;
    var paused = false;
    var prefersReducedMotion =
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function show(index) {
      for (var i = 0; i < slides.length; i++) {
        slides[i].classList.toggle('is-active', i === index);
      }
      for (var j = 0; j < dots.length; j++) {
        dots[j].classList.toggle('is-active', j === index);
      }
      current = index;
    }

    function next() {
      show((current + 1) % slides.length);
    }

    function start() {
      if (timer || prefersReducedMotion || paused) return;
      timer = setInterval(next, interval);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    slider.addEventListener('mouseenter', function () { paused = true; stop(); });
    slider.addEventListener('mouseleave', function () { paused = false; start(); });
    slider.addEventListener('focusin', function () { paused = true; stop(); });
    slider.addEventListener('focusout', function () { paused = false; start(); });

    for (var k = 0; k < dots.length; k++) {
      (function (i) {
        dots[i].addEventListener('click', function () {
          stop();
          show(i);
          start();
        });
      })(k);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stop();
      } else {
        start();
      }
    });

    start();
  }

  function init() {
    initScrollReveal();
    initHeroParallax();
    initHeroSlider();
    initScrollNav();
    initEmailForm();
    initRitualReveal();
    initStickyCta();
    initLoomDrawer();
    initCartIconDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ── Shopify design mode: re-init on section events ────────
     Ensures animations re-trigger when sections are
     reordered or added in the theme editor.
  ─────────────────────────────────────────────────────────── */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      // Reset and re-observe on section load
      document.querySelectorAll('.reveal.is-visible').forEach(function (el) {
        el.classList.remove('is-visible');
      });
      initScrollReveal();
    });
  }

  /* ── Product Page: Image Gallery ─────────────────────────── */
  function initProductGallery() {
    var mainImg = document.getElementById('loom-pdp-main-img');
    var thumbs = document.getElementById('loom-pdp-thumbs');
    if (!mainImg || !thumbs) return;

    thumbs.addEventListener('click', function (e) {
      var btn = e.target.closest('.loom-pdp-hero__thumb');
      if (!btn) return;
      if (btn.classList.contains('is-active')) return;

      var url = btn.getAttribute('data-image-url');
      var srcset = btn.getAttribute('data-image-srcset');
      var sizes = btn.getAttribute('data-image-sizes');
      var alt = btn.getAttribute('data-image-alt');
      if (!url) return;

      // Instant swap — apply srcset/sizes BEFORE src so the browser picks
      // the right variant when it fetches (or hits the warm cache from preload).
      if (srcset) {
        mainImg.setAttribute('srcset', srcset);
      } else {
        mainImg.removeAttribute('srcset');
      }
      if (sizes) {
        mainImg.setAttribute('sizes', sizes);
      }
      mainImg.src = url;
      mainImg.alt = alt || '';

      thumbs.querySelectorAll('.loom-pdp-hero__thumb').forEach(function (t) {
        t.classList.remove('is-active');
      });
      btn.classList.add('is-active');
    });

    // Warm the browser cache for every gallery image after the page goes idle.
    // Subsequent thumb clicks become instant cache hits. Runs after LCP so
    // it doesn't compete with the main image's initial fetch.
    function preloadGallery() {
      var btns = thumbs.querySelectorAll('.loom-pdp-hero__thumb');
      for (var i = 0; i < btns.length; i++) {
        var url = btns[i].getAttribute('data-image-url');
        var srcset = btns[i].getAttribute('data-image-srcset');
        var sizes = btns[i].getAttribute('data-image-sizes');
        if (!url) continue;
        var img = new Image();
        if (sizes) img.sizes = sizes;
        if (srcset) img.srcset = srcset;
        img.src = url;
      }
    }

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(preloadGallery, { timeout: 2500 });
    } else {
      setTimeout(preloadGallery, 1500);
    }
  }

  /* ── Product Page: Variant Selector ──────────────────────── */
  function initVariantSelector() {
    var container = document.getElementById('loom-pdp-variants');
    if (!container) return;

    var variantsJson = document.getElementById('loom-pdp-variants-json');
    if (!variantsJson) return;

    var variants = [];
    try { variants = JSON.parse(variantsJson.textContent); } catch (e) { return; }

    var selectedOptions = {};

    container.querySelectorAll('.loom-pdp-hero__variant-btn.is-active').forEach(function (btn) {
      selectedOptions[btn.getAttribute('data-option-index')] = btn.getAttribute('data-value');
    });

    container.addEventListener('click', function (e) {
      var btn = e.target.closest('.loom-pdp-hero__variant-btn');
      if (!btn) return;

      var idx = btn.getAttribute('data-option-index');
      var val = btn.getAttribute('data-value');
      selectedOptions[idx] = val;

      var group = btn.closest('.loom-pdp-hero__variant-options');
      group.querySelectorAll('.loom-pdp-hero__variant-btn').forEach(function (b) {
        b.classList.remove('is-active');
      });
      btn.classList.add('is-active');

      var optionValues = [];
      var groups = container.querySelectorAll('.loom-pdp-hero__variant-group');
      for (var i = 0; i < groups.length; i++) {
        optionValues.push(selectedOptions[String(i)] || '');
      }

      var match = null;
      for (var j = 0; j < variants.length; j++) {
        var v = variants[j];
        var matched = true;
        for (var k = 0; k < optionValues.length; k++) {
          if (v.options[k] !== optionValues[k]) {
            matched = false;
            break;
          }
        }
        if (matched) { match = v; break; }
      }

      if (match) {
        document.getElementById('loom-pdp-variant-id').value = match.id;
        var priceEl = document.querySelector('.loom-pdp-hero__price-current');
        if (priceEl) priceEl.textContent = formatMoney(match.price);

        var compareEl = document.querySelector('.loom-pdp-hero__price-compare');
        if (compareEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            compareEl.textContent = formatMoney(match.compare_at_price);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }

        var atcBtn = document.getElementById('loom-pdp-atc');
        if (atcBtn) {
          atcBtn.disabled = !match.available;
          atcBtn.textContent = match.available ? 'ADD TO BAG' : 'SOLD OUT';
        }
      }
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ── Product Page: Add to Cart (AJAX) ────────────────────── */
  function initAddToCart() {
    var form = document.getElementById('loom-pdp-form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var variantId = document.getElementById('loom-pdp-variant-id').value;
      addToCart(variantId, 1);
    });

    var stickyBtn = document.getElementById('loom-sticky-atc-btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var variantId = document.getElementById('loom-pdp-variant-id').value;
        addToCart(variantId, 1);
      });
    }

    var duoBtn = document.getElementById('loom-pdp-duo-atc');
    if (duoBtn) {
      duoBtn.addEventListener('click', function () {
        var duoId = duoBtn.getAttribute('data-duo-variant-id');
        if (duoId) {
          addToCart(duoId, 1);
        }
      });
    }
  }

  function addToCart(variantId, qty) {
    if (!variantId) return;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty || 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        refreshAndOpenDrawer();
        updateCartBubble();
      })
      .catch(function (err) {
        console.error('Cart add error:', err);
      });
  }

  /* ── Loomera Cart Drawer ─────────────────────────────────── */
  function initLoomDrawer() {
    var drawer = document.getElementById('loom-cart-drawer');
    if (!drawer) return;

    var overlay = document.getElementById('loom-drawer-overlay');
    var closeBtn = document.getElementById('loom-drawer-close');
    var continueBtn = document.getElementById('loom-drawer-continue');
    var continueEmptyBtn = document.getElementById('loom-drawer-continue-empty');
    var upsellBtn = document.getElementById('loom-drawer-upsell-btn');
    var itemsEl = document.getElementById('loom-drawer-items');

    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('loom-drawer-open');
    }

    if (overlay) overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (continueBtn) continueBtn.addEventListener('click', close);
    if (continueEmptyBtn) continueEmptyBtn.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        close();
      }
    });

    if (itemsEl) {
      itemsEl.addEventListener('click', function (e) {
        var removeBtn = e.target.closest('.loom-drawer-item__remove');
        if (removeBtn) {
          var line = parseInt(removeBtn.getAttribute('data-line'), 10);
          changeItemQuantity(line, 0);
          return;
        }

        var qtyBtn = e.target.closest('.loom-drawer-item__qty-btn');
        if (qtyBtn) {
          var itemEl = qtyBtn.closest('.loom-drawer-item');
          var line = parseInt(itemEl.getAttribute('data-line'), 10);
          var currentQty = parseInt(qtyBtn.parentNode.querySelector('.loom-drawer-item__qty-value').textContent, 10);
          var action = qtyBtn.getAttribute('data-action');
          var newQty = action === 'increase' ? currentQty + 1 : currentQty - 1;
          changeItemQuantity(line, Math.max(0, newQty));
        }
      });
    }

    if (upsellBtn) {
      upsellBtn.addEventListener('click', function () {
        var duoVariantId = drawer.getAttribute('data-duo-variant-id');
        if (duoVariantId) {
          addToCart(duoVariantId, 1);
        }
      });
    }
  }

  function changeItemQuantity(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderDrawerItems(cart);
        updateCartBubble();
      });
  }

  function refreshAndOpenDrawer() {
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderDrawerItems(cart);
        openDrawer();
      });
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function shouldShowDuoUpsell(cart) {
    var drawer = document.getElementById('loom-cart-drawer');
    if (!drawer) return false;
    var singleHandle = drawer.getAttribute('data-single-handle');
    var duoHandle = drawer.getAttribute('data-duo-handle');
    var duoVariantId = drawer.getAttribute('data-duo-variant-id');
    if (!singleHandle || !duoHandle || !duoVariantId) return false;

    var hasSingle = false;
    var hasDuo = false;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].handle === singleHandle) hasSingle = true;
      if (cart.items[i].handle === duoHandle) hasDuo = true;
    }
    return hasSingle && !hasDuo;
  }

  function renderDrawerItems(cart) {
    var itemsEl = document.getElementById('loom-drawer-items');
    var emptyEl = document.getElementById('loom-drawer-empty');
    var subtotalEl = document.getElementById('loom-drawer-subtotal');
    var footerEl = document.getElementById('loom-drawer-footer');
    var upsellEl = document.getElementById('loom-drawer-upsell');

    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '';
      if (emptyEl) emptyEl.style.display = '';
      if (footerEl) footerEl.style.display = 'none';
      if (upsellEl) upsellEl.classList.remove('is-visible');
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';
    if (footerEl) footerEl.style.display = '';

    var html = '';
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var imgSrc = item.image ? item.image.replace(/(\.[^.]+)$/, '_150x$1') : '';
      var title = escapeHtml(item.product_title || '');
      var variantTitle = (item.variant_title && item.variant_title !== 'Default Title') ? escapeHtml(item.variant_title) : '';

      html += '<div class="loom-drawer-item" data-line="' + (i + 1) + '" data-variant-id="' + item.variant_id + '">';
      html += imgSrc
        ? '<img class="loom-drawer-item__image" src="' + imgSrc + '" alt="' + title + '" width="72" height="72" loading="lazy">'
        : '<div class="loom-drawer-item__image"></div>';
      html += '<div class="loom-drawer-item__details">';
      html += '<p class="loom-drawer-item__name">' + title + '</p>';
      if (variantTitle) html += '<p class="loom-drawer-item__variant">' + variantTitle + '</p>';
      html += '<div class="loom-drawer-item__qty-controls">';
      html += '<button type="button" class="loom-drawer-item__qty-btn" data-action="decrease" aria-label="Decrease quantity">';
      html += '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="5" y1="12" x2="19" y2="12"/></svg>';
      html += '</button>';
      html += '<span class="loom-drawer-item__qty-value">' + item.quantity + '</span>';
      html += '<button type="button" class="loom-drawer-item__qty-btn" data-action="increase" aria-label="Increase quantity">';
      html += '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
      html += '</button>';
      html += '</div>';
      html += '</div>';
      html += '<div class="loom-drawer-item__right">';
      html += '<span class="loom-drawer-item__price">' + formatMoney(item.final_line_price) + '</span>';
      html += '<button type="button" class="loom-drawer-item__remove" data-line="' + (i + 1) + '">Remove</button>';
      html += '</div>';
      html += '</div>';
    }
    itemsEl.innerHTML = html;

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    if (upsellEl) {
      if (shouldShowDuoUpsell(cart)) {
        upsellEl.classList.add('is-visible');
      } else {
        upsellEl.classList.remove('is-visible');
      }
    }
  }

  function openDrawer() {
    var drawer = document.getElementById('loom-cart-drawer');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('loom-drawer-open');
  }

  function updateCartBubble() {
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bubbles = document.querySelectorAll('.cart-count-bubble span[aria-hidden]');
        bubbles.forEach(function (el) { el.textContent = cart.item_count; });
        var srBubbles = document.querySelectorAll('.cart-count-bubble .visually-hidden');
        srBubbles.forEach(function (el) { el.textContent = cart.item_count + ' items'; });
      });
  }

  /* ── Sticky ATC Bar ──────────────────────────────────────── */
  function initStickyATC() {
    var stickyBar = document.getElementById('loom-sticky-atc');
    var heroAtc = document.getElementById('loom-pdp-atc');
    if (!stickyBar || !heroAtc) return;

    if (window.matchMedia('(min-width: 990px)').matches) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            stickyBar.classList.remove('is-visible');
            stickyBar.setAttribute('aria-hidden', 'true');
          } else {
            stickyBar.classList.add('is-visible');
            stickyBar.setAttribute('aria-hidden', 'false');
          }
        });
      },
      { threshold: 0, rootMargin: '0px' }
    );

    observer.observe(heroAtc);
  }

  /* ── Product Page Init ───────────────────────────────────── */
  function initProductPage() {
    initProductGallery();
    initVariantSelector();
    initAddToCart();
    initStickyATC();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductPage);
  } else {
    initProductPage();
  }

})();
